import { logger } from '@tuic/logger';
import { cache } from 'react';

import { Account } from '../../index';

type GetFlightInformation = (args: {
  idToken: string;
  bookingCode: string;
}) => Promise<Account.GetProfileMyTripsByBookingCodeFlightResponse | null>;

export const getBookingFlight: GetFlightInformation = async ({
  idToken,
  bookingCode,
}) => {
  const { data, error } = await Account.getProfileMyTripsByBookingCodeFlight({
    path: {
      bookingCode: bookingCode,
    },
    auth: idToken,
  });

  if (error) {
    logger.error('Could not fetch flight-data.');
    logger.error(error);

    return null;
  }

  return data ?? null;
};

export const memoizedGetBookingFlight: GetFlightInformation =
  cache(getBookingFlight);
